import { useState } from "react";
import { HiLocationMarker } from "react-icons/hi";
import { ShopsGrantedCredentials } from "../../@types/Auth";
import { useAuth } from "../../hooks/auth";
import StyledInput from "./components/Input/index";
import * as S from "./styles";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTranslateRouteName } from "../../hooks/useTranslateRouteName";

interface Filters {
  tenantName: string;
  shopName: string;
}

export function Dashboard() {
  const { user, shopSelected, selectStore } = useAuth();
  const [filters, setFilters] = useState<Filters>({
    tenantName: "",
    shopName: "",
  });

  const location = useLocation();
  const { translateRouteName } = useTranslateRouteName();
  const { t } = useTranslation();

  const [isAscending, setIsAscending] = useState(true);

  const activeShops = user.user.shopsGranted.filter((shop) => shop.active);

  const selectedShop = activeShops.filter(
    (shop) => shop.name === (shopSelected && shopSelected.name),
  );

  const filterStores = activeShops.filter((shop) => {
    const isSameSelectedShop =
      selectedShop[0] && shop.name === selectedShop[0].name;

    const nameFilter =
      !isSameSelectedShop &&
      shop.name
        .toLocaleLowerCase()
        .includes(filters.shopName.toLocaleLowerCase());

    const tenantNameFilter =
      shop.tenantName &&
      shop.tenantName
        .toLocaleLowerCase()
        .includes(filters.tenantName.toLocaleLowerCase());

    return nameFilter && tenantNameFilter;
  });

  const filteredStores = [...filterStores].sort((a, b) =>
    isAscending ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name),
  );
  const shopsToShow = selectedShop.concat(filteredStores);

  const handleSelectStore = async (shop: ShopsGrantedCredentials) => {
    await selectStore(shop);
  };

  const handleUpdateFilter = (filter: keyof Filters, value: string) => {
    setFilters((state) => ({
      ...state,
      [filter]: value,
    }));
  };

  const handleToggleOrder = () => {
    setIsAscending((prev) => !prev);
  };

  return (
    <S.StoreContainer>
      <S.ResponsiveTitle>
        {translateRouteName(location.pathname)}
      </S.ResponsiveTitle>
      <StyledInput
        onToggleOrder={handleToggleOrder}
        searchIcon
        placeholder={t("search")}
        onChange={(event) => handleUpdateFilter("shopName", event.target.value)}
      />

      <S.StoresContainer>
        {shopsToShow.map((store) => {
          return (
            <S.StoresCardContainer key={store.id}>
              <S.StoreCardContent>
                <S.StoreWrapperText>
                  <S.StoreCardInfoContent>
                    <S.StyledSpan>
                      {store.name.toLocaleLowerCase()}
                    </S.StyledSpan>
                  </S.StoreCardInfoContent>

                  <S.StoreCardInfoContent>
                    <HiLocationMarker size={16} />
                    <S.StyledSpan isSecond>
                      {store.name === "Warehouse"
                        ? "San Dimas"
                        : store.name.toLocaleLowerCase()}
                      , {store.state}
                    </S.StyledSpan>
                  </S.StoreCardInfoContent>
                </S.StoreWrapperText>
                <button
                  disabled={store.name === shopSelected.name}
                  onClick={() => handleSelectStore(store)}
                >
                  {store.name === shopSelected.name
                    ? t("selected")
                    : t("access")}
                </button>
              </S.StoreCardContent>
            </S.StoresCardContainer>
          );
        })}
      </S.StoresContainer>
    </S.StoreContainer>
  );
}
